module.exports = __webpack_public_path__ + "static/media/banner-video-1.392893f1.mp4";